var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMemo } from 'react';
import 'whatwg-fetch';
export var useFetch = function (accessToken) {
    return useMemo(function () {
        if (!accessToken) {
            throw new Error('accessToken is required');
        }
        var request = function (url, options) { return __awaiter(void 0, void 0, void 0, function () {
            var res, text, data, message, error;
            var _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0: return [4 /*yield*/, fetch(url, __assign(__assign({}, options), { headers: __assign(__assign({}, options === null || options === void 0 ? void 0 : options.headers), { Authorization: "Access-Token ".concat(accessToken) }) }))];
                    case 1:
                        res = _h.sent();
                        if (!(res.status >= 200 && res.status < 300)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.text()];
                    case 2:
                        text = _h.sent();
                        if (!text) {
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/, JSON.parse(text)];
                    case 3: return [4 /*yield*/, res.json().catch(function () { return ({}); })];
                    case 4:
                        data = _h.sent();
                        message = (_g = (_f = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.meta) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : (_e = data === null || data === void 0 ? void 0 : data.meta) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : res.statusText) !== null && _g !== void 0 ? _g : "Request failed with status ".concat(res.status);
                        error = new Error(message);
                        error.response = { data: data, status: res.status };
                        throw error;
                }
            });
        }); };
        var post = function (url, body, options) {
            var config = __assign(__assign({}, options), { method: 'POST', body: JSON.stringify(body) });
            return request(url, config);
        };
        var get = function (url, params, options) {
            var urlWithParams = "".concat(url);
            if (params !== undefined) {
                var paramsString = new URLSearchParams(params).toString();
                urlWithParams = "".concat(urlWithParams, "?").concat(paramsString);
            }
            return request(urlWithParams, options);
        };
        var deleteRecord = function (url, options) {
            var config = __assign(__assign({}, options), { method: 'DELETE' });
            return request(url, config);
        };
        var update = function (url, body, options) {
            var config = __assign(__assign({}, options), { body: JSON.stringify(body) });
            return request(url, config);
        };
        return {
            post: post,
            get: get,
            delete: deleteRecord,
            update: update,
        };
    }, [accessToken]);
};
